import { render, staticRenderFns } from "./MayberLoader.vue?vue&type=template&id=37ab0e3b&scoped=true&functional=true&"
import script from "./MayberLoader.vue?vue&type=script&lang=js&"
export * from "./MayberLoader.vue?vue&type=script&lang=js&"
import style0 from "./MayberLoader.vue?vue&type=style&index=0&id=37ab0e3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "37ab0e3b",
  null
  
)

export default component.exports